<div class="head">
  <h1 class="page-title">Accounts</h1>
</div>

<p class="loading" *ngIf="loading">Loading your accounts…</p>
<p class="error" *ngIf="error">{{ error }}</p>

<p class="empty" *ngIf="!loading && !error && !summaries.length">
  No accounts yet — import a CSV to create one.
</p>

<div class="account-grid" *ngIf="!loading && !error">
  <article class="account-card" *ngFor="let a of summaries; trackBy: trackAccount">
    <div class="card-head">
      <h2 class="name">{{ a.name }}</h2>
      <span class="kind">{{ a.kind }}</span>
    </div>

    <div class="balance" *ngIf="a.balanceCents !== null">
      <span class="value">{{ fmt(a.balanceCents) }}</span>
      <span class="asof">as of {{ a.balanceDate + 'T00:00:00' | date:'MMM d, y' }}</span>
    </div>
    <div class="balance none" *ngIf="a.balanceCents === null">
      <span class="value">—</span>
      <span class="asof">this export carries no balance</span>
    </div>

    <dl class="facts">
      <div><dt>Spent, 30 days</dt><dd>{{ fmt(a.windowSpendCents) }}</dd></div>
      <div><dt>Transactions</dt><dd>{{ a.txnCount }}</dd></div>
      <div><dt>History</dt>
        <dd *ngIf="a.firstDate">{{ a.firstDate + 'T00:00:00' | date:'MMM d, y' }}<span *ngIf="a.lastDate"> → {{ a.lastDate + 'T00:00:00' | date:'MMM d, y' }}</span></dd>
        <dd *ngIf="!a.firstDate">—</dd>
      </div>
    </dl>

    <div class="balance-chart" *ngIf="balancePoints(a.id).length > 1">
      <h4>Balance by month</h4>
      <mm-line [points]="balancePoints(a.id)"
               [displayValues]="balanceDisplay(a.id)"
               [ariaLabel]="a.name + ' balance by month'"></mm-line>
    </div>
  </article>
</div>
